import { gql } from '@apollo/client';

const GET_CASE_TYPE_OPTIONS = gql`
  query GetCaseTypeOptions {
    caseWorkOptions {
      caseTypes {
        cycleDateRequired
        label
        team
        value
      }
      teams {
        label
        value
      }
    }
  }
`;

export { GET_CASE_TYPE_OPTIONS };
